<div class="spinner-container">
  <div class="spinner" [style.backgroundColor]="color ? color : ''"></div>
</div>
